export const SUPPORTED_COUNTRIES = ['PK', 'SA', 'GB', 'CO', 'AE', 'QA'];
export const UI_LOCALES = ['en', 'ar', 'es', 'ur-Latn'];
export const TAX_REGIME_CODES = ['pk_sales_tax', 'sa_zatca', 'uk_vat', 'co_iva', 'ae_vat', 'none'];
export const TAX_CATEGORIES = ['standard', 'zero', 'exempt', 'out_of_scope'];
export const IDENTITY_DOC_TYPES = [
    'pk_cnic',
    'pk_nicop',
    'pk_bform',
    'sa_nid',
    'sa_iqama',
    'sa_border',
    'sa_visa',
    'gcc_id',
    'gb_nhs',
    'gb_chi',
    'gb_hc',
    'co_cc',
    'co_ce',
    'co_ti',
    'co_rc',
    'co_ppt',
    'co_cn',
    'ae_eid',
    'ae_uid',
    'qa_qid',
    'passport',
    'no_document',
];
export const ID_MISSING_REASONS = ['unidentified', 'newborn', 'not_held', 'refused'];
//# sourceMappingURL=types.js.map